<script lang="ts">
    import {scrollIntoView} from '../Common.svelte';

    let navBarOpen = false;

    function clickOutside(node) {
        const handleClick = event => {
            if (node && !node.contains(event.target) && !event.defaultPrevented) {
                node.dispatchEvent(
                    new CustomEvent('click_outside', node)
                )
            }
        }

        document.addEventListener('click', handleClick, true);

        return {
            destroy() {
                document.removeEventListener('click', handleClick, true);
            }
        }
    }

    function handleClickOutside(event) {
        navBarOpen = false;
    }
</script>

<header
        class="fixed z-50 bg-white shadow-sm w-full"
>
    <div class="container">
        <div class="flex -mx-4 items-center justify-between relative">
            <div class="px-4 w-60 max-w-full">
                <a href="/" class="w-full block py-5">
                    <img
                            src="images/logo.svg"
                            alt="logo"
                            class="w-full"
                    />
                </a>
            </div>
            <div use:clickOutside on:click_outside={handleClickOutside}
                 class="flex px-4 justify-between items-center w-full">
                <div>
                    <button
                            on:click={() => navBarOpen = !navBarOpen}
                            id="navbarToggler"
                            class="
                              block
                              absolute
                              right-4
                              top-1/2
                              -translate-y-1/2
                              lg:hidden
                              focus:ring-2
                              ring-primary
                              px-3
                              py-[6px]
                              rounded-lg
                              {navBarOpen && 'navbarTogglerActive'}
                            "
                    >
                <span
                        class="relative w-[30px] h-[2px] my-[6px] block bg-body-color"
                ></span>
                        <span
                                class="relative w-[30px] h-[2px] my-[6px] block bg-body-color"
                        ></span>
                        <span
                                class="relative w-[30px] h-[2px] my-[6px] block bg-body-color"
                        ></span>
                    </button>
                    <nav
                            id="navbarCollapse"
                            class="
                              absolute
                              py-5
                              px-6
                              bg-white
                              shadow
                              rounded-lg
                              max-w-[250px]
                              w-full
                              lg:max-w-full lg:w-full
                              right-4
                              lg:block lg:static lg:shadow-none
                              transition-all
                              top-full
                              {!navBarOpen && 'hidden'}
                            "
                    >
                        <ul class="block lg:flex">
                            <li>
                                <a
                                        on:click|preventDefault={scrollIntoView}
                                        href="#home"
                                        class="
                        text-base
                        font-medium
                        text-dark
                        hover:text-primary
                        py-2
                        lg:inline-flex
                        flex
                        lg:ml-12
                      "
                                >
                                    Home
                                </a>
                            </li>
                            <li>
                                <a
                                        on:click|preventDefault={scrollIntoView}
                                        href="#features"
                                        class="
                                        text-base
                                        font-medium
                                        text-dark
                                        hover:text-primary
                                        py-2
                                        lg:inline-flex
                                        flex
                                        lg:ml-12
                                      "
                                >
                                    Features
                                </a>
                            </li>
                            <li>
                                <a
                                        on:click|preventDefault={scrollIntoView}
                                        href="#newsletter"
                                        class="
                        text-base
                        font-medium
                        text-dark
                        hover:text-primary
                        py-2
                        lg:inline-flex
                        flex
                        lg:ml-12
                      "
                                >
                                    Newsletter
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</header>